import PropTypes from 'prop-types'
import { useSelector, useDispatch } from 'react-redux'
import classnames from 'classnames'

// Selectors
import { selectYlopoOptIn } from '../../../../store/selectors/client'

// Components
import { Button, ExternalLinkButton, If } from '../../..'

// Actions
import { toggleYlopoOptInModal } from '../../../../actions/listings'

const YlopoListingsButton = ({
  listingsUrl,
  className,
  children,
  ...restProps
}) => {
  const dispatch = useDispatch()
  const clientYlopoOptIn = useSelector(selectYlopoOptIn)
  // If a client has no client answers, an empty array is returned from
  // selectYlopoOptIn
  const clientHasOptedIn =
    clientYlopoOptIn !== undefined &&
    !(Array.isArray(clientYlopoOptIn) && !clientYlopoOptIn.length)

  return (
    <>
      <If condition={clientHasOptedIn}>
        <ExternalLinkButton
          className={classnames(className)}
          data-qa='ylopoListingsButton'
          href={listingsUrl}
          role='link'
          {...restProps}
        >
          {children}
        </ExternalLinkButton>
      </If>
      <If condition={!clientHasOptedIn}>
        <Button
          className={classnames(className)}
          onClick={() => dispatch(toggleYlopoOptInModal(listingsUrl))}
          {...restProps}
        >
          {children}
        </Button>
      </If>
    </>
  )
}

YlopoListingsButton.propTypes = {
  className: PropTypes.string,
  listingsUrl: PropTypes.string,
  children: PropTypes.any,
}

export default YlopoListingsButton
